module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/336.1267dc46.png";